import useApiController from "@hooks/useApiController"

export default function useSalonController(): Customer.Controllers.Salon {
    const { show, ...controller } = useApiController("/api/customer/salons")

    const current = controller.get('current')
    const participating = controller.get('participating')
    const past = controller.get('past')
    const participate = (id: string | number) => controller.post(`${id}/participate`)

    return { current, participating, past, show, participate }
}